import { render, staticRenderFns } from "./MyActivitiesHub.vue?vue&type=template&id=73b40d8d&scoped=true"
import script from "./MyActivitiesHub.vue?vue&type=script&lang=js"
export * from "./MyActivitiesHub.vue?vue&type=script&lang=js"
import style0 from "./MyActivitiesHub.vue?vue&type=style&index=0&id=73b40d8d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b40d8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b40d8d')) {
      api.createRecord('73b40d8d', component.options)
    } else {
      api.reload('73b40d8d', component.options)
    }
    module.hot.accept("./MyActivitiesHub.vue?vue&type=template&id=73b40d8d&scoped=true", function () {
      api.rerender('73b40d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/MyActivitiesHub.vue"
export default component.exports